'use strict';

// function smoothScrollToElement(element, duration = 1000) {
//     var targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
//     var startPosition = window.pageYOffset;
//     var distance = targetPosition - startPosition;
//     if (distance === 0) return;
//     let startTime = null;

//     function animation(currentTime) {
//         if (startTime === null) startTime = currentTime;
//         var timeElapsed = currentTime - startTime;
//         var run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
//         window.scrollTo(0, run);
//         if (timeElapsed < duration) {
//             requestAnimationFrame(animation);
//         } else {
//             window.scrollTo(0, targetPosition);
//         }
//     }

//     function easeInOutQuad(t, b, c, d) {
//         t /= d / 2;
//         if (t < 1) return c / 2 * t * t + b;
//         t--;
//         return -c / 2 * (t * (t - 2) - 1) + b;
//     }

//     requestAnimationFrame(animation);
// }

// function addEventListeners() {
//     if ('scrollRestoration' in history) {
//         history.scrollRestoration = 'manual';
//     }

//     window.addEventListener('load', function () {
//         window.scrollTo(0, 0);

//         var hash = window.location.hash;
//         if (hash) {
//             var target = document.querySelector(hash);
//             if (target) {
//                 setTimeout(() => {
//                     smoothScrollToElement(target, 2000);
//                 }, 100);
//             }
//         }
//     });

//     window.addEventListener('hashchange', function () {
//         var hash = window.location.hash;
//         var target = document.querySelector(hash);
//         if (target) {
//             smoothScrollToElement(target, 2000);
//         }
//     });
// }

function initAnchorSmoothScrollFix() {

    function normalizePath(p) {
        if (!p) return "/";
        p = p.replace(/\/+$/, "");
        return (p === "/home") ? "/" : (p || "/");
    }

    const here = normalizePath(location.pathname);
    const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

    function smoothTo(hash) {
        if (!hash) return;
        const el = document.querySelector(hash);
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function closeMobileMenu() {
        if (!isMobile()) return;

        const closeBtn =
        document.querySelector('.js-close-menu-layout') ||
        document.querySelector('.menu-layout__trigger [class*="close" i]');

        if (closeBtn) { try { closeBtn.click(); return; } catch (_) {} }

        const ariaClose = document.querySelector('[aria-label*="close" i], [aria-label*="dismiss" i]');
        if (ariaClose) { try { ariaClose.click(); return; } catch (_) {} }

        document.documentElement.classList.remove('menu-open','nav-open','lock-scroll');
        document.body.classList.remove('menu-open','nav-open','lock-scroll');

        const open = document.querySelector('.is-open, .menu--open, .main-nav--open, .mobile-menu--open');
        if (open) open.classList.remove('is-open','menu--open','main-nav--open','mobile-menu--open');
    }

    document.addEventListener("click", function (e) {
        const a = e.target.closest('a[href]');
        if (!a) return;
        if (e.defaultPrevented || a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const url = new URL(a.getAttribute("href"), location.href);
        if (url.origin !== location.origin) return;

        const path = normalizePath(url.pathname);
        const hasHash = !!url.hash;

        if ((path === here || (path === "/" && here === "/")) && hasHash) {
        const target = document.querySelector(url.hash);
        if (target) {
            e.preventDefault();
            history.pushState(null, "", url.hash);
            smoothTo(url.hash);
            closeMobileMenu();
            return;
        }
        }

        if ((path === here || (path === "/" && here === "/")) && !hasHash) {
        e.preventDefault();
        history.pushState(null, "", "#top");
        const topEl = document.querySelector("#top") || document.body;
        (topEl === document.body ? window : topEl).scrollTo({ top: 0, behavior: "smooth" });
        closeMobileMenu();
        }

    }, { capture: true });

    window.addEventListener("popstate", function () {
        if (location.hash) smoothTo(location.hash);
        else window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("load", function () {
        if (location.hash) smoothTo(location.hash);
    });

}

var init = function() {

    initAnchorSmoothScrollFix();

};

module.exports = {
	init: init
};